export default __webpack_public_path__ + "static/media/lungs.1ecf2934.svg";